
import { defineComponent } from "vue";
import api, { SimsSignal } from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import format from "xml-formatter";
import { AxiosError } from "axios";

interface State {
  msg: string;
  signal: SimsSignal;
  errors: AxiosError[];
}

export default defineComponent({
  name: "SimsSignalForm",
  mounted() {
    this.$nextTick(() => {
      this.callGetSimsSignal();
    });
  },
  data: (): State => {
    let signal = { } as SimsSignal;
    return {
      msg: "Sims Signal",
      signal: signal,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    formatXml(xml: string): string {
      return format(xml, {collapseContent: false});
    },
    callGetSimsSignal() {

      let signal_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      signal_id = this.$route.params.slug

      api
        .getSimsSignal(signal_id)
        .then((response) => {
          this.signal = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  }
});
